"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var system_1 = require("@mui/system");
var StyledAccordion = (0, system_1.styled)(Accordion_1.default)({
    borderTop: "1px solid #E1E1E1",
    minHeight: "56px",
    padding: "0px",
    boxShadow: "none",
    borderBottom: "1px solid #E1E1E1",
    '&:not(:last-child)': {
        borderBottom: '8px',
    },
    '&:first-of-type': {
        borderTop: "1px solid #E1E1E1",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
    },
    '&:last-of-type': {
        borderBottomLeftRadius: "0px",
        borderBottomRightRadius: "0px",
    },
    '&::before': {
        display: "none",
    },
});
var Accordion = function (_a) {
    var _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? false : _b, _c = _a.disableGutters, disableGutters = _c === void 0 ? true : _c, expanded = _a.expanded, _d = _a.square, square = _d === void 0 ? false : _d, disabled = _a.disabled, onChange = _a.onChange, children = _a.children, classes = _a.classes, _e = _a.sx, sx = _e === void 0 ? {} : _e, style = _a.style, key = _a.key, testid = _a["data-testid"];
    return (react_1.default.createElement(StyledAccordion, { elevation: 0, square: square, defaultExpanded: defaultExpanded, disableGutters: disableGutters, expanded: expanded, disabled: disabled, onChange: onChange, children: children, classes: classes, sx: sx, style: style, key: key, "data-testid": testid }));
};
exports.default = Accordion;
__exportStar(require("@mui/material/Accordion"), exports);
//# sourceMappingURL=index.js.map